import React from 'react';

import { FormattedMessage } from 'react-intl';

import messages from './messages';

const RateErrorLabel = <FormattedMessage {...messages.rateErrorLabel} />;

export default RateErrorLabel;
